// extracted by mini-css-extract-plugin
export var equalColumn = "_fz-0";